import { DECISION, TIMELINE } from "../../lib/manualKit";

export const Timeline = () => (
  <div className="grid lg:grid-cols-2 gap-8" data-testid="manual-timeline">
    <div>
      <p className="label-xs mb-4">Dispute timeline</p>
      <ol className="relative border-l border-brand/40 ml-2 space-y-6">
        {TIMELINE.map(([d, t], i) => (
          <li key={d} className="pl-6 relative" data-testid={`timeline-${i}`}>
            <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 bg-brand" style={{ boxShadow: "0 0 10px rgb(var(--brand-rgb)/0.7)" }} />
            <p className="font-mono text-xs text-brand tracking-wider">{d}</p>
            <p className="text-sm text-white/75 mt-1">{t}</p>
          </li>
        ))}
      </ol>
    </div>
    <div>
      <p className="label-xs mb-4">Decision tree · refund or defend?</p>
      <div className="space-y-3">
        {DECISION.map((n, i) => (
          <div key={n.q} className="panel p-4" data-testid={`decision-${i}`}>
            <p className="font-bold text-sm"><span className="font-mono text-brand mr-2">Q{i + 1}</span>{n.q}</p>
            <div className="grid sm:grid-cols-2 gap-3 mt-3 text-[13px]">
              <p className="border-l-2 border-brand pl-3 text-white/80"><span className="font-mono text-[10px] text-brand block">YES</span>{n.yes}</p>
              <p className="border-l-2 border-white/20 pl-3 text-white/60"><span className="font-mono text-[10px] text-white/40 block">NO</span>{n.no}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
